module.exports = __webpack_public_path__ + "static/docs/Vermietungsplaene_Tuefwis_Keller_Haus_E_200115.51fe1d44.pdf";